"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOvertimePreviewItemDto = instanceOfOvertimePreviewItemDto;
exports.OvertimePreviewItemDtoFromJSON = OvertimePreviewItemDtoFromJSON;
exports.OvertimePreviewItemDtoFromJSONTyped = OvertimePreviewItemDtoFromJSONTyped;
exports.OvertimePreviewItemDtoToJSON = OvertimePreviewItemDtoToJSON;
exports.OvertimePreviewItemDtoToJSONTyped = OvertimePreviewItemDtoToJSONTyped;
const OvertimePreviewShiftDto_1 = require("./OvertimePreviewShiftDto");
/**
 * Check if a given object implements the OvertimePreviewItemDto interface.
 */
function instanceOfOvertimePreviewItemDto(value) {
    if (!('zealEmployeeCheckId' in value) || value['zealEmployeeCheckId'] === undefined)
        return false;
    if (!('nurseName' in value) || value['nurseName'] === undefined)
        return false;
    if (!('facilityNames' in value) || value['facilityNames'] === undefined)
        return false;
    if (!('totalHours' in value) || value['totalHours'] === undefined)
        return false;
    if (!('overtimeHours' in value) || value['overtimeHours'] === undefined)
        return false;
    if (!('estOvertimeCents' in value) || value['estOvertimeCents'] === undefined)
        return false;
    if (!('shifts' in value) || value['shifts'] === undefined)
        return false;
    return true;
}
function OvertimePreviewItemDtoFromJSON(json) {
    return OvertimePreviewItemDtoFromJSONTyped(json, false);
}
function OvertimePreviewItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'zealEmployeeCheckId': json['zealEmployeeCheckId'],
        'nurseName': json['nurseName'],
        'facilityNames': json['facilityNames'],
        'totalHours': json['totalHours'],
        'overtimeHours': json['overtimeHours'],
        'estOvertimeCents': json['estOvertimeCents'],
        'shifts': (json['shifts'].map(OvertimePreviewShiftDto_1.OvertimePreviewShiftDtoFromJSON)),
    };
}
function OvertimePreviewItemDtoToJSON(json) {
    return OvertimePreviewItemDtoToJSONTyped(json, false);
}
function OvertimePreviewItemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'zealEmployeeCheckId': value['zealEmployeeCheckId'],
        'nurseName': value['nurseName'],
        'facilityNames': value['facilityNames'],
        'totalHours': value['totalHours'],
        'overtimeHours': value['overtimeHours'],
        'estOvertimeCents': value['estOvertimeCents'],
        'shifts': (value['shifts'].map(OvertimePreviewShiftDto_1.OvertimePreviewShiftDtoToJSON)),
    };
}
//# sourceMappingURL=OvertimePreviewItemDto.js.map